<template>
    <div class="f-topic-main-content">
        <div v-if="topicInfo.extBeanList.length"
           class="f-topic-main-content-ext-wrapper">
           <table-component></table-component>
        </div>

        <div class="f-topic-main-content-content">
            <rich-text :html-snip="topicInfo.content">
            </rich-text>
        </div>

        <div class="f-topic-main-content-related">
            <div class="f-topic-main-content-related-info">
                <div class="f-topic-main-content-tag"
                    v-if="Object.prototype.toString.call(tagInfo) === '[object Object]'
                        && Object.keys(tagInfo).length > 0">
                    <span class="f-topic-main-content-tag-info">{{tagInfo.tag_name}}</span>
                </div>

                <div class="f-topic-main-content-time">
                    <span class="f-topic-main-content-time-word">
                        最后一次编辑于&nbsp;{{topicInfo.lastModifiedTime}}
                    </span>    
                </div>
            </div>
        </div>

        <div id="official-board" class="f-topic-main-content-like">
            <like-btn
                :isLike="isEvaluated"
                class="f-topic-main-content-like-btn"
                @like="changeTopicLikeState">
            </like-btn>
            <div class="f-topic-main-content-like-num">
                {{topicInfo.evaluationCount}}个赞
            </div>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/topic-content/main-content.less';
</style>

<script>
import LikeBtn from './LikeBtn.vue';
import {mapState} from 'vuex';
import RichText from '@/views/components/rich-text';
import Table from './table';

export default {
    components: {
        'like-btn': LikeBtn,
        'rich-text': RichText,
        'table-component': Table
    },
    metaInfo() {
        return {
            title: `${this.topicInfo.title} - 智能小程序开发者社区`,
            meta: [{
                name: 'keywords',
                content: `${this.fixedWords},${this.topicInfo.title}`
            }, {
                name: 'description',
                content: this.filterContent(this.topicInfo.content)
            }]
        };
    },
    computed: {
        ...mapState({
            topicInfo: state => state.topicContent.topicData.topicInfo,
            tagInfo: state => state.topicContent.topicData.tagInfo,
            isEvaluated: state => state.topicContent.topicData.isEvaluated,
            fixedWords: state => state.common.metaInfo.fixedWords,
            isSwan: state => state.common.isSwan
        })
    },
    methods: {
        changeTopicLikeState() {
            this.$emit('changeTopicLikeState');
        },
        // 去掉html标签
        filterContent(content) {
            return content
                .replace(/(\r\n|\n)/g, '')
                .replace(/\s/g, '')
                .replace(/<[^>]+>/g, '').substr(0, 200);
        }
    }
};
</script>
